import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "mas mas-fill-1" }, "account_balance", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_modal_button = _resolveComponent("base-modal-button")!
  const _component_alert_info = _resolveComponent("alert-info")!
  const _component_base_tab_link = _resolveComponent("base-tab-link")!
  const _component_CbLibraryOverview = _resolveComponent("CbLibraryOverview")!
  const _component_base_tab_pane = _resolveComponent("base-tab-pane")!
  const _component_base_tab = _resolveComponent("base-tab")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_ctx.isReady && _ctx.contentBlockTypesWithLibrary.includes(_ctx.cbType))
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createVNode(_component_base_modal_button, {
          class: _normalizeClass(["btn btn-warning btn-icon", _ctx.buttonClass]),
          "modal-id": _ctx.modalId
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default", {}, () => [
              _hoisted_1
            ])
          ]),
          _: 3
        }, 8, ["class", "modal-id"]),
        _createVNode(_component_base_modal, {
          "modal-id": _ctx.modalId,
          "dialog-classes": "modal-xl modal-dialog-scrollable",
          title: (_ctx.title ?? '') + ' ' + _ctx.$t('library')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_alert_info, {
              description: _ctx.$t('descriptionLibraries'),
              class: "mb-3"
            }, null, 8, ["description"]),
            _createVNode(_component_base_tab, { "tab-id": _ctx.tabId }, {
              tabs: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentBlockLibsForType, (contentBlockLibForType, i) => {
                  return (_openBlock(), _createBlock(_component_base_tab_link, {
                    key: contentBlockLibForType.library.code,
                    target: _ctx.targetId(contentBlockLibForType.library.code),
                    title: contentBlockLibForType.library.description,
                    "is-active": i === 0
                  }, null, 8, ["target", "title", "is-active"]))
                }), 128))
              ]),
              content: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentBlockLibsForType, (contentBlockLibForType, i) => {
                  return (_openBlock(), _createBlock(_component_base_tab_pane, {
                    key: contentBlockLibForType.library.code,
                    id: _ctx.targetId(contentBlockLibForType.library.code),
                    "is-active": i === 0
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CbLibraryOverview, {
                        "cb-type": _ctx.cbType,
                        "library-code": contentBlockLibForType.library.code,
                        onExceptions: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('exceptions', $event))),
                        onSelect: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('select', $event)))
                      }, null, 8, ["cb-type", "library-code"])
                    ]),
                    _: 2
                  }, 1032, ["id", "is-active"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["tab-id"])
          ]),
          _: 1
        }, 8, ["modal-id", "title"])
      ], 64))
    : _createCommentVNode("", true)
}